import React, { useState, useEffect } from 'react';
import axios from 'axios';

const MarketManager = () => {
  const [products, setProducts] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({
    type: 'cash',
    name: '',
    description: '',
    price: '',
    stock: '',
    orderIndex: 0,
    isActive: true
  });
  const [imageFile, setImageFile] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.get('/api/market/admin', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setProducts(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
      alert('Ürünler yüklenirken bir hata oluştu');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('adminToken');
      const formDataToSend = new FormData();

      Object.keys(formData).forEach(key => {
        if (formData[key] !== null && formData[key] !== undefined) {
          formDataToSend.append(key, formData[key]);
        }
      });

      if (imageFile) {
        formDataToSend.append('image', imageFile);
      } else if (editingItem && editingItem.imageUrl) {
        formDataToSend.append('imageUrl', editingItem.imageUrl || editingItem.image_url);
      }

      if (editingItem) {
        await axios.put(`/api/market/${editingItem.id}`, formDataToSend, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        });
      } else {
        await axios.post('/api/market', formDataToSend, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        });
      }

      alert(editingItem ? 'Ürün güncellendi' : 'Ürün eklendi');
      setShowForm(false);
      setEditingItem(null);
      setFormData({
        type: 'cash',
        name: '',
        description: '',
        price: '',
        stock: '',
        orderIndex: 0,
        isActive: true
      });
      setImageFile(null);
      fetchProducts();
    } catch (error) {
      console.error('Error saving product:', error);
      alert(error.response?.data?.error || 'Ürün kaydedilirken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (product) => {
    setEditingItem(product);
    setFormData({
      type: product.type || 'cash',
      name: product.name || '',
      description: product.description || '',
      price: product.price || '',
      stock: product.stock || '',
      orderIndex: product.orderIndex || product.order_index || 0,
      isActive: product.isActive !== undefined ? product.isActive : (product.is_active === 1 || product.is_active === true)
    });
    setImageFile(null);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu ürünü silmek istediğinize emin misiniz?')) {
      return;
    }

    try {
      const token = localStorage.getItem('adminToken');
      await axios.delete(`/api/market/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert('Ürün silindi');
      fetchProducts();
    } catch (error) {
      console.error('Error deleting product:', error);
      alert('Ürün silinirken bir hata oluştu');
    }
  };

  const handleToggleActive = async (product) => {
    try {
      const token = localStorage.getItem('adminToken');
      await axios.put(`/api/market/${product.id}`, {
        ...formData,
        type: product.type || 'cash',
        name: product.name || '',
        description: product.description || '',
        price: product.price || '',
        stock: product.stock || '',
        orderIndex: product.orderIndex || product.order_index || 0,
        isActive: !(product.isActive !== undefined ? product.isActive : (product.is_active === 1 || product.is_active === true)),
        imageUrl: product.imageUrl || product.image_url || null
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchProducts();
    } catch (error) {
      console.error('Error toggling active:', error);
      alert('Durum güncellenirken bir hata oluştu');
    }
  };

  const handleOrderChange = async (productId, newOrder) => {
    try {
      const token = localStorage.getItem('adminToken');
      const product = products.find(p => p.id === productId);
      if (!product) return;

      await axios.put(`/api/market/${productId}`, {
        type: product.type || 'cash',
        name: product.name || '',
        description: product.description || '',
        price: product.price || '',
        stock: product.stock || '',
        orderIndex: newOrder,
        isActive: product.isActive !== undefined ? product.isActive : (product.is_active === 1 || product.is_active === true),
        imageUrl: product.imageUrl || product.image_url || null
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchProducts();
    } catch (error) {
      console.error('Error updating order:', error);
      alert('Sıralama güncellenirken bir hata oluştu');
    }
  };

  return (
    <div className="bg-gradient-card rounded-xl p-6 border border-gold/30">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gold">Market Yönetimi</h2>
        <button
          onClick={() => {
            setShowForm(true);
            setEditingItem(null);
            setFormData({
              type: 'cash',
              name: '',
              description: '',
              price: '',
              stock: '',
              orderIndex: products.length,
              isActive: true
            });
            setImageFile(null);
          }}
          className="bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-bold px-6 py-2 rounded-lg transition-all duration-300 shadow-gold"
        >
          + Yeni Ürün Ekle
        </button>
      </div>

      {/* Form */}
      {showForm && (
        <div className="mb-6 p-6 bg-navy-800 rounded-lg border border-gold/20">
          <h3 className="text-xl font-bold text-gold mb-4">
            {editingItem ? 'Ürün Düzenle' : 'Yeni Ürün Ekle'}
          </h3>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-white mb-2">Ürün Tipi *</label>
                <select
                  value={formData.type}
                  onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                  className="w-full px-4 py-2 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
                  required
                >
                  <option value="cash">Nakit Ödül</option>
                  <option value="product">Ürün</option>
                </select>
              </div>

              <div>
                <label className="block text-white mb-2">Sıra</label>
                <input
                  type="number"
                  value={formData.orderIndex}
                  onChange={(e) => setFormData({ ...formData, orderIndex: parseInt(e.target.value) || 0 })}
                  className="w-full px-4 py-2 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
                />
              </div>
            </div>

            <div>
              <label className="block text-white mb-2">Ürün Adı *</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className="w-full px-4 py-2 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
                required
                placeholder="Örn: 100 TL Nakit Ödül"
              />
            </div>

            <div>
              <label className="block text-white mb-2">Açıklama</label>
              <textarea
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                className="w-full px-4 py-2 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
                rows="3"
                placeholder="Ürün açıklaması"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-white mb-2">Puan Değeri *</label>
                <input
                  type="number"
                  value={formData.price}
                  onChange={(e) => setFormData({ ...formData, price: e.target.value })}
                  className="w-full px-4 py-2 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
                  required
                  min="1"
                  placeholder="Örn: 500"
                />
              </div>

              <div>
                <label className="block text-white mb-2">Stok Sayısı</label>
                <input
                  type="number"
                  value={formData.stock}
                  onChange={(e) => setFormData({ ...formData, stock: e.target.value })}
                  className="w-full px-4 py-2 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
                  min="0"
                  placeholder="0 = sınırsız"
                />
              </div>
            </div>

            <div>
              <label className="block text-white mb-2">Görsel</label>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setImageFile(e.target.files[0])}
                className="w-full px-4 py-2 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
              />
              {editingItem && editingItem.imageUrl && !imageFile && (
                <img 
                  src={editingItem.imageUrl || editingItem.image_url} 
                  alt="Preview" 
                  className="mt-2 h-32 object-contain rounded bg-navy-900 p-2" 
                />
              )}
            </div>

            <div className="flex items-center gap-4">
              <label className="flex items-center gap-2 text-white">
                <input
                  type="checkbox"
                  checked={formData.isActive}
                  onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                  className="w-4 h-4"
                />
                Aktif
              </label>
            </div>

            <div className="flex gap-2">
              <button
                type="submit"
                disabled={loading}
                className="bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-bold px-6 py-2 rounded-lg transition-all duration-300 shadow-gold disabled:opacity-50"
              >
                {loading ? 'Kaydediliyor...' : (editingItem ? 'Güncelle' : 'Ekle')}
              </button>
              <button
                type="button"
                onClick={() => {
                  setShowForm(false);
                  setEditingItem(null);
                  setImageFile(null);
                }}
                className="bg-gray-500 hover:bg-gray-600 text-white px-6 py-2 rounded-lg transition-colors"
              >
                İptal
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Products List */}
      <div className="space-y-4">
        {products.map((product, index) => {
          const orderIndex = product.orderIndex || product.order_index || 0;
          return (
            <div
              key={product.id}
              className={`p-4 rounded-lg border-2 ${
                product.isActive !== undefined ? product.isActive : (product.is_active === 1 || product.is_active === true)
                  ? 'bg-navy-800 border-gold/30'
                  : 'bg-navy-900/50 border-gray-600/30 opacity-60'
              }`}
            >
              <div className="flex items-start justify-between">
                <div className="flex gap-4 flex-1">
                  {/* Sıralama Göstergesi */}
                  <div className="flex flex-col items-center justify-center min-w-[60px]">
                    <div className="bg-gold/20 border-2 border-gold rounded-lg px-3 py-2 mb-2">
                      <div className="text-gold font-bold text-lg text-center">{orderIndex}</div>
                      <div className="text-gold/70 text-xs text-center">Sıra</div>
                    </div>
                    <div className="flex flex-col gap-1">
                      {index > 0 && (
                        <button
                          onClick={() => handleOrderChange(product.id, orderIndex - 1)}
                          className="bg-navy-700 hover:bg-navy-600 text-white px-2 py-1 rounded text-xs transition-colors"
                          title="Yukarı taşı"
                        >
                          ↑
                        </button>
                      )}
                      {index < products.length - 1 && (
                        <button
                          onClick={() => handleOrderChange(product.id, orderIndex + 1)}
                          className="bg-navy-700 hover:bg-navy-600 text-white px-2 py-1 rounded text-xs transition-colors"
                          title="Aşağı taşı"
                        >
                          ↓
                        </button>
                      )}
                    </div>
                  </div>

                  {product.imageUrl || product.image_url ? (
                    <img
                      src={product.imageUrl || product.image_url}
                      alt={product.name}
                      className="w-24 h-24 object-contain rounded bg-navy-900 p-2"
                    />
                  ) : (
                    <div className="w-24 h-24 bg-navy-900 rounded flex items-center justify-center text-white/40">
                      Görsel Yok
                    </div>
                  )}
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2 flex-wrap">
                      <span className={`px-3 py-1 rounded text-sm font-semibold ${
                        product.type === 'cash' 
                          ? 'bg-green-500/20 text-green-400' 
                          : 'bg-blue-500/20 text-blue-400'
                      }`}>
                        {product.type === 'cash' ? 'Nakit Ödül' : 'Ürün'}
                      </span>
                      <span className="text-white/80 text-sm font-medium">
                        Market'te {orderIndex + 1}. sırada gösterilecek
                      </span>
                      {(product.isActive !== undefined ? product.isActive : (product.is_active === 1 || product.is_active === true)) ? (
                        <span className="px-2 py-1 bg-green-500/20 text-green-400 rounded text-xs">Aktif</span>
                      ) : (
                        <span className="px-2 py-1 bg-red-500/20 text-red-400 rounded text-xs">Pasif</span>
                      )}
                    </div>
                    <h3 className="text-white font-bold text-lg mb-1">{product.name}</h3>
                    {product.description && (
                      <p className="text-white/70 text-sm mb-2">{product.description}</p>
                    )}
                    <div className="flex gap-4 text-sm">
                      <span className="text-gold font-semibold">💰 {product.price || 0} Sagu Coin</span>
                      <span className="text-white/60">📦 Stok: {product.stock !== null && product.stock !== undefined ? product.stock : 'Sınırsız'}</span>
                    </div>
                  </div>
                </div>
                <div className="flex gap-2 ml-4">
                  <button
                    onClick={() => handleEdit(product)}
                    className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg transition-colors text-sm"
                  >
                    Düzenle
                  </button>
                  <button
                    onClick={() => handleToggleActive(product)}
                    className={`px-4 py-2 rounded-lg transition-colors text-sm ${
                      product.isActive !== undefined ? product.isActive : (product.is_active === 1 || product.is_active === true)
                        ? 'bg-yellow-500 hover:bg-yellow-600 text-navy-900'
                        : 'bg-green-500 hover:bg-green-600 text-white'
                    }`}
                  >
                    {(product.isActive !== undefined ? product.isActive : (product.is_active === 1 || product.is_active === true)) ? 'Pasif Yap' : 'Aktif Yap'}
                  </button>
                  <button
                    onClick={() => handleDelete(product.id)}
                    className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg transition-colors text-sm"
                  >
                    Sil
                  </button>
                </div>
              </div>
            </div>
          );
        })}

        {products.length === 0 && (
          <div className="text-center text-white/60 py-8">
            <p>Henüz ürün eklenmedi</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MarketManager;
